import "./shippingPolicy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxOpen,
  faTruck,
  faCheckCircle,
  faClock
} from "@fortawesome/free-solid-svg-icons";

export default function ShippingPolicy() {
  return (
    <main className="policyPage">
      <div className="policyContainer">
        <h1>Shipping Policy</h1>

        <div className="policyCard">
          <div className="policyHeader">
            <FontAwesomeIcon icon={faBoxOpen} className="policyIcon" />
            <h2>Processing Time</h2>
          </div>
          <p>
            All orders are processed within 1–2 business days. Orders placed on
            weekends or public holidays will be processed the next working day.
          </p>
        </div>

        <div className="policyCard">
          <div className="policyHeader">
            <FontAwesomeIcon icon={faTruck} className="policyIcon" />
            <h2>Delivery Time</h2>
          </div>
          <p>UAE delivery typically takes 2–4 working days after dispatch.</p>
          <p>
            Delivery timelines may vary during peak seasons or promotional
            periods.
          </p>
        </div>

        <div className="policyCard">
          <div className="policyHeader">
            <FontAwesomeIcon icon={faCheckCircle} className="policyIcon" />
            <h2>Shipping Confirmation</h2>
          </div>
          <p>
            Once your order is dispatched, you will receive a confirmation
            message with tracking details (if applicable).
          </p>
        </div>

        <div className="policyCard">
          <div className="policyHeader">
            <FontAwesomeIcon icon={faClock} className="policyIcon" />
            <h2>Delivery Delays</h2>
          </div>
          <p>
            While we aim to deliver within the estimated timeframe, Tote Therapy
            is not responsible for delays caused by courier services or
            unforeseen circumstances.
          </p>
        </div>
      </div>
    </main>
  );
}